globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.NpsReminder = (function() {

    function NpsReminder() {
        this.$NpsReminder = $('#nps-reminder');
        this.$npsNotes = this.$NpsReminder.find(".nps-reminder-note")
        this.$npsCloseButtonDesktop = this.$NpsReminder.find("#nps-close-button-desktop")
        this.$npsCloseButtonMobile = this.$NpsReminder.find("#nps-close-button-mobile")
        this.init();
    }

    NpsReminder.prototype = {
        init : function() {
            var npsModal = this;
            npsModal.animateIn();
            npsModal.$npsNotes.on("click", function(){
                npsModal.$NpsReminder.hide();
            });
            npsModal.$npsCloseButtonDesktop.on("click", function(){
                npsModal.$NpsReminder.hide();
                utils.cookies.create('nps_modal_closed', true, 168)
            });
            npsModal.$npsCloseButtonMobile.on("click", function(){
                npsModal.$NpsReminder.hide();
                utils.cookies.create('nps_modal_closed', true, 168)
            });
        },
        animateIn : function() {
            var npsModal = this;
            setTimeout(function() {
                npsModal.$NpsReminder.fadeIn("slow")
            }, 1000);
        }
    }

    return NpsReminder;

})();
